// extracted by mini-css-extract-plugin
export default {"dark":"tzlm4m","light":"o8tfyr"};